// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1zIhs","itemTitle":"ClientEmergencyInfo_itemTitle__2hiAz","itemText":"ClientEmergencyInfo_itemText__1mKgq"};